import { gql } from "@apollo/client";

export const GET_LISTAR_MINUTA_GRILLA = gql`
    query GetListarMinutas($filtros: ListarMinutaFilterInput!) {
        listarMinutas(filtros: $filtros) {
            idMinuta,
            cliente,
            codClienteSAP,
            modulo,
            cantidadConexion,
            precioTotal,
            paciente,
            delegacion,
            numeroFactura,
            fechaPrimerConexion,
            codigoLista,
            grupoArticulo,
            codigoArticulo,
            tipoPrecio,
            vigencia,
            precioControl,
            fA,
            cotizado,
            estadoPrecioMinuta,
            estadoPrecioEvaluacion,
            idEvaluacion,
            precioDiario,
            fechaAlta,
            planCuidado,
            estadoMinuta,
            precioSAP,
            check,
            idJustificacionMinuta,
            observaciones,
            codSAP
        }
    }
`;

export const adaptListarMinutaGrilla = (minuta) => {
  return {
    idMinuta: minuta?.idMinuta,
    cliente: minuta?.cliente,
    codClienteSAP: minuta?.codClienteSAP,
    modulo: minuta?.modulo,
    cantidadConexion: minuta?.cantidadConexion,
    precioTotal: minuta?.precioTotal,
    paciente: minuta?.paciente,
    delegacion: minuta?.delegacion,
    numeroFactura: minuta?.numeroFactura,
    fechaPrimerConexion: minuta?.fechaPrimerConexion,
    codigoLista: minuta?.codigoLista,
    grupoArticulo: minuta?.grupoArticulo,
    codigoArticulo: minuta?.codigoArticulo,
    tipoPrecio: minuta?.tipoPrecio,
    vigencia: minuta?.vigencia,
    precioControl: minuta?.precioControl,
    fA: minuta?.fA,
    cotizado: minuta?.cotizado,
    estadoPrecioMinuta: minuta?.estadoPrecioMinuta,
    estadoPrecioEvaluacion: minuta?.estadoPrecioEvaluacion,
    idEvaluacion: minuta?.idEvaluacion,
    precioDiario: minuta?.precioDiario,
    fechaAlta: minuta?.fechaAlta,
    planCuidado: minuta?.planCuidado,
    estadoMinuta: minuta?.estadoMinuta,
    precioSAP: minuta?.precioSAP,
    check: minuta?.check,
    idJustificacionMinuta: minuta?.idJustificacionMinuta,
    observaciones: minuta?.observaciones,
    codSAP: minuta?.codSAP
  };
};

export const adaptListarMinutaGrillaArray = (minutas) => {
  return structuredClone(minutas)?.
  map((minuta) => adaptListarMinutaGrilla(minuta));
};